/* eslint-disable */
import { useState, useEffect } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import { CircularProgress, Grid, Dialog, DialogContent, Modal } from "@mui/material";
// import Icon from "@mui/material/Icon";
import Swal from "sweetalert2";

// Soft UI Dashboard PRO React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import TranferPopup from "components/TranferPopup/TranferPopup";
import { ResponseAlert } from "components/ResponseAlert";
import { GameLobbyURL, startUfa, startBetflix } from "api/member";
import { EligibleTranfer, BetflixTranfer, UfaTranfer } from "api/tranfer";

import breakpoints from "assets/theme/base/breakpoints";
import { RingLoader, DotLoader } from "react-spinners";

// Custom styles for the MasterCard
import styles from "./styles";

import ufagame from "../../../../assets/png/ufagame2.png";
import betflixgame from "../../../../assets/png/betflixgame2.png";
import huaydragongame from "../../../../assets/png/huaydragongame2.png";
import AGENT_MAINTENANCE from "../../../../assets/png/AGENT_MAINTENANCE_TEXT.png";
import AG_MEMBER_LOCKED from "../../../../assets/png/AG_MEMBER_LOCKED.png";
import gearGIF from "../../../../assets/gif/gear.gif";
import playbtn from "../../../../assets/png/playbtn.png";
import AGENT_NOT_AVAILABLE_TEXT from "../../../../assets/png/AGENT_NOT_AVAILABLE_TEXT.png";

const betflixLinks = [
  "https://www.083510.com",
  "https://www.083511.com",
  "https://www.083512.com",
  "https://www.083513.com",
  "https://www.083514.com",
  "https://www.083515.com",
];

function AgentCircle({ color, isLoading, agent, image, balance, agentBalance, onFetchBalance }) {
  const classes = styles({ color, agent, image });
  const [memberBalance, setMemberBalance] = useState(balance);
  const [memberAgBalance, setMemberAGBalance] = useState(agentBalance);
  const [isTranferPopup, setTranferPopup] = useState(false);
  const [isCreating, setIsCreating] = useState(false);
  const [isTranfer, setTranfer] = useState(false);
  const [isOpen, setOpen] = useState(false);
  const [mobileView, setMobileView] = useState(false);
  // const [eligibleTranfer, setEligible] = useState(false);
  // const [isAutoPlay, setAutoPlay] = useState(false);
  const formatter = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  async function handleTranferPopup() {
    try {
      const response = await EligibleTranfer();
      console.log("handleTranferPopup-response", response);
      if (response?.data?.status === "success") {
        if (response?.data?.data?.eligible) {
          if (agent !== "lottery") {
            setTranferPopup(true);
          }
        } else {
          const sec = response?.data?.data?.wait;
          const wait = 5 - Number(sec);
          console.log("handleTranferPopup-wait", wait);
          alert(`คุณลูกค้าสามารถโยกเงินได้อีกครั้งในอีก ${wait} วินาที`);
        }
      }
    } catch (err) {
      ResponseAlert(err?.response);
      console.log("handleTranferPopup", err);
      console.log("handleTranferPopup", err.response);
    }
  }

  function randomLinkBetflix(links) {
    return links[Math.floor(Math.random() * links.length)];
  }

  async function startGame() {
    if (isLoading || isCreating || isTranfer) {
      return;
    }
    if (memberAgBalance === "INVALID_MEMBER") {
      handleStartMember();
    } else {
      handleTranfer();
    }
  }

  async function handleTranfer() {
    if (memberBalance > 0) {
      handleTranferCredit();
    } else {
      getLobbyUrl();
    }
  }

  async function handleTranferCredit() {
    console.log("AgentCircle - handleTranferCredit - memberBalance", memberBalance);
    setTranfer(true);
    const payload = {
      type: "add",
      credit: memberBalance,
    };

    let tranfer = BetflixTranfer;
    if (agent === "ufa") {
      tranfer = UfaTranfer;
    }

    try {
      await tranfer(payload);
      setTranfer(false);
      getLobbyUrl();
    } catch (err) {
      setTranfer(false);
    }
  }

  async function getLobbyUrl() {
    setOpen(true);
    if (memberAgBalance !== "AGENT_MAINTENANCE") {
      try {
        const gameLobby = await GameLobbyURL({ agent });
        if (gameLobby?.data?.status === "success") {
          // Swal.close();
          if (agent === "betflix") {
            const loginToken = await gameLobby?.data?.data?.betflix?.login_token;
            if (loginToken) {
              const bflink = randomLinkBetflix(betflixLinks);
              const betflixUrl = `${bflink}/login/apilogin/${loginToken}`;

              window.open(betflixUrl, "_self");
            }
          }
          if (agent === "ufa") {
            const gameUrl = await gameLobby?.data?.data?.ufa?.gameUrl;
            if (gameUrl) {
              window.open(gameUrl, "_self");
            }
          }
        }
        setOpen(false);
      } catch (err) {
        // Swal.close();
        setOpen(false);
        ResponseAlert(err?.response);
        console.log("getLobbyUrl-catch-error", err);
        console.log("getLobbyUrl-catch-error-response", err.response);
      }
    }
  }

  async function handleStartMember() {
    let startAgent = startUfa;
    if (agent === "betflix") {
      startAgent = startBetflix;
    }

    setIsCreating(true);
    try {
      const response = await startAgent();
      console.log("handleStartMember-response", response);
      setIsCreating(false);
      if (response?.data?.status !== "success") {
        ResponseAlert(response);
      } else {
        handleTranfer();
      }
    } catch (error) {
      setIsCreating(false);
      ResponseAlert(error.response);
    }
  }

  useEffect(() => {
    if (window.innerWidth < breakpoints.values.lg) {
      setMobileView(true);
    } else {
      setMobileView(false);
    }
    setMemberAGBalance(agentBalance);
    setMemberBalance(balance);
  }, [balance, agentBalance]);

  console.log("memberAgBalance", memberAgBalance);
  return (
    <SuiBox width="100%" height="100%">
      <Modal
        open={isCreating || isTranfer || isOpen ? true : false}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <SuiBox
          width="100%"
          height="100%"
          backgroundColor="rgba(0, 0, 0, 0.1)"
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <RingLoader color="#17c1e8" />
        </SuiBox>
      </Modal>
      <SuiBox backgroundColor="rgba(0, 0, 0, 0.3)" borderRadius="lg" py={1}>
        <SuiBox sx={{ cursor: isCreating || isTranfer || isOpen ? "auto" : "pointer" }}>
          {agent === "ufa" && (
            <SuiBox display="flex" justifyContent="center" px={1}>
              <SuiBox
                component="img"
                src={ufagame}
                alt="ufa"
                width="100%"
                onClick={() => startGame()}
              />
            </SuiBox>
          )}
          {agent === "betflix" && (
            <SuiBox display="flex" justifyContent="center" px={1}>
              <SuiBox
                component="img"
                src={betflixgame}
                alt="betflix"
                width="100%"
                onClick={() => startGame()}
              />
            </SuiBox>
          )}
          {agent === "huaydragon" && (
            <SuiBox display="flex" justifyContent="center" px={1}>
              <SuiBox
                component="img"
                src={huaydragongame}
                alt="lottery"
                width="100%"
                onClick={() => getLobbyUrl()}
              />
            </SuiBox>
          )}
        </SuiBox>
        <SuiBox>
          <SuiBox
            onClick={agent === "huaydragon" ? () => getLobbyUrl() : () => startGame()}
            sx={{ cursor: isCreating || isTranfer || isOpen ? "auto" : "pointer" }}
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <SuiBox component="img" src={playbtn} alt="playbtn" width="40%" />
          </SuiBox>
        </SuiBox>

        {isLoading ? (
          <SuiBox display="flex" justifyContent="center" alignItems="center">
            {/* <CircularProgress size="2rem" /> */}
          </SuiBox>
        ) : (
          <>
            {memberAgBalance === "INVALID_MEMBER" ||
            memberAgBalance === "NOT_AVAILABLE" ||
            memberAgBalance === "AGENT_MAINTENANCE" ||
            memberAgBalance === "AG_MEMBER_LOCKED" ? (
              <SuiBox display="flex" justifyContent="center" alignItems="center" widht="100%">
                {memberAgBalance === "NOT_AVAILABLE" && (
                  <SuiBox display="flex" justifyContent="center" alignItems="center" mt={2}>
                    <Grid sx={{}} container justifyContent="center" alignItems="center">
                      <Grid item lg={12}>
                        <SuiBox display="flex" justifyContent="center">
                          <SuiBox component="img" src={gearGIF} alt="gearGIF" width="40%" />
                        </SuiBox>
                      </Grid>
                      <Grid item lg={12}>
                        <SuiBox display="flex" justifyContent="center">
                          <SuiBox
                            component="img"
                            src={AGENT_NOT_AVAILABLE_TEXT}
                            alt="AGENT_NOT_AVAILABLE"
                            width="80%"
                          />
                        </SuiBox>
                      </Grid>
                    </Grid>
                  </SuiBox>
                )}
                {memberAgBalance === "AGENT_MAINTENANCE" && (
                  <SuiBox display="flex" justifyContent="center" alignItems="center" mt={2}>
                    <Grid sx={{}} container justifyContent="center" alignItems="center">
                      <Grid item lg={12}>
                        <SuiBox display="flex" justifyContent="center">
                          <SuiBox component="img" src={gearGIF} alt="gearGIF" width="40%" />
                        </SuiBox>
                      </Grid>
                      <Grid item lg={12}>
                        <SuiBox display="flex" justifyContent="center">
                          <SuiBox
                            component="img"
                            src={AGENT_MAINTENANCE}
                            alt="AGENT_MAINTENANCE"
                            width="80%"
                          />
                        </SuiBox>
                      </Grid>
                    </Grid>
                  </SuiBox>
                )}
                {memberAgBalance === "AG_MEMBER_LOCKED" && (
                  <SuiBox display="flex" justifyContent="center" alignItems="center">
                    <Grid sx={{}} container justifyContent="center" alignItems="center">
                      <Grid item lg={12}>
                        <SuiBox display="flex" justifyContent="center">
                          <SuiBox
                            component="img"
                            src={AG_MEMBER_LOCKED}
                            alt="AG_MEMBER_LOCKED"
                            width="80%"
                          />
                        </SuiBox>
                      </Grid>
                      <Grid item lg={12}></Grid>
                    </Grid>
                  </SuiBox>
                )}
              </SuiBox>
            ) : (
              <SuiBox
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
              ></SuiBox>
            )}
          </>
        )}
      </SuiBox>
    </SuiBox>
  );
}

// Setting default values for the props of MasterCard
AgentCircle.defaultProps = {
  color: "dark",
  isLoading: false,
  agent: "ufa",
  balance: "0.00",
  agentBalance: "0.00",
  onFetchBalance: () => {},
};

// Typechecking props for the MasterCard
AgentCircle.propTypes = {
  color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark"]),
  isLoading: PropTypes.bool,
  agent: PropTypes.string,
  image: PropTypes.string.isRequired,
  balance: PropTypes.string,
  agentBalance: PropTypes.string,
  onFetchBalance: PropTypes.func,
};

export default AgentCircle;
